import { SearchableItem } from '@core/search';
import { SearchIndexBuilder } from '../utils/search-index.builder';

export interface SettingsPayload {
  category: string;
  route: string;
  section?: string;
}

/**
 * Adapter: takes the existing in-module SearchIndexBuilder output and
 * lifts it into the generic SearchableItem<SettingsPayload> shape that
 * the IntelligentSearchService expects.
 *
 * Per-item keywords are overlaid from settings-keywords.<lang>.json at
 * runtime by SettingsSearchProvider (richer than the inline 7-keyword
 * arrays in the legacy builder).
 */
const CATEGORY_LABEL_KEY: Record<string, string> = {
  general: 'SETTINGS.CATEGORIES.GENERAL',
  'time-tracking': 'SETTINGS.CATEGORIES.TIME_TRACKING',
  shift: 'SETTINGS.CATEGORIES.SHIFT',
  terminal: 'SETTINGS.CATEGORIES.TERMINALS',
  surcharge: 'SETTINGS.CATEGORIES.SURCHARGE',
  datev: 'SETTINGS.CATEGORIES.DATEV',
  ml: 'SETTINGS.CATEGORIES.ML',
  holidays: 'SETTINGS.CATEGORIES.HOLIDAYS',
  ui: 'SETTINGS.CATEGORIES.UI',
  subscription: 'SETTINGS.CATEGORIES.SUBSCRIPTION',
  tasks: 'SETTINGS.CATEGORIES.TASKS',
};

const ROOT_BREADCRUMB_KEY = 'SETTINGS.NAV_TITLE';

export function buildSettingsIndex(
  keywordsByItemId: Record<string, string[]>
): SearchableItem<SettingsPayload>[] {
  const legacy = SearchIndexBuilder.buildCompleteIndex();
  return legacy.map((it) => ({
    id: `settings:${it.id}`,
    providerId: 'settings',
    title: it.title,
    description: it.description,
    keywords: keywordsByItemId[it.id] ?? it.keywords ?? [],
    breadcrumb: [
      ROOT_BREADCRUMB_KEY,
      CATEGORY_LABEL_KEY[it.category] ?? it.category,
    ],
    icon: it.icon,
    payload: {
      category: it.category,
      route: it.route,
      section: it.section,
    },
  }));
}
